import { type PlateEditor, type TNode, createPluginFactory, exitBreak as exitBreakTransform } from "@udecode/plate";
import { type BaseEditor, Editor } from "slate";

import { getParentTable } from "../components/decisionTable/transforms";
import { ELEMENT_SECTION } from "../components/section/sectionConstants";
import { withHotKeys } from "../plugins/util";

// getParentSection normally lives in sectionModals.tsx, but that file pulls in
// heavy modal UI (and transitively RuleAuthor/multiEditor) - inlined here to
// keep this module's own dependency graph small.
const getParentSection = (editor: BaseEditor) =>
  Editor.above(editor, { match: (n) => (n as TNode).type === ELEMENT_SECTION });

/*
Calculate the parent level to exit to. This ensures that mod+ctrl consistently moves you to the parent editor, ie:
 - If you are in a table inside a section then you will move to the section.
 - If you are in a table inside the root section you will move to the root editor.
 - If you are in a section you should go to the root editor.
 - If you are in the root section this will do nothing
*/
export const exitBreakLevel = (editor: BaseEditor) => {
  const containerEntry = getParentTable(editor) ?? getParentSection(editor);
  return containerEntry ? containerEntry[1].length - 1 : 0;
};

export const createSectionAwareExitBreakPlugin = createPluginFactory({
  key: "exitBreak",
  ...withHotKeys([
    {
      keys: "mod+enter",
      action: (editor: PlateEditor) => exitBreakTransform(editor, { level: exitBreakLevel(editor as BaseEditor) }),
    },
    {
      keys: "mod+shift+enter",
      action: (editor: PlateEditor) =>
        exitBreakTransform(editor, { level: exitBreakLevel(editor as BaseEditor), before: true }),
    },
  ]),
});
